<div class="p-4 border-t border-neutral-3 bg-white dark:bg-neutral-2 flex flex-col gap-2 relative group">
  <!-- Expand / Collapse Toggle Button -->
  <button
    type="button"
    (click)="toggleExpand()"
    class="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-all duration-200 z-10 size-7 bg-white dark:bg-neutral-3 border border-neutral-3 dark:border-neutral-4 text-neutral-10 hover:text-neutral-12 dark:text-neutral-10 dark:hover:text-neutral-12 rounded-full flex items-center justify-center shadow-sm hover:shadow hover:scale-110 active:scale-95 cursor-pointer"
    [title]="isExpanded() ? 'Réduire la zone de saisie' : 'Agrandir la zone de saisie'"
  >
    <mat-icon
      class="!w-4 !h-4 !text-[16px] flex items-center justify-center transition-transform duration-300"
      [class.rotate-180]="isExpanded()"
    >
      keyboard_arrow_up
    </mat-icon>
  </button>

  @if (replyText() && replySenderName()) {
    <div
      class="flex items-center justify-between bg-neutral-2 dark:bg-neutral-3/20 rounded-xl px-4 py-2 border-l-4 border-primary text-xs"
    >
      <button
        type="button"
        (click)="replyClicked.emit()"
        class="flex flex-col min-w-0 cursor-pointer hover:opacity-80 transition-opacity text-left"
      >
        <span class="font-bold text-primary mb-0.5 select-none">
          {{ replySenderName() }}
        </span>
        <span class="text-neutral-10 truncate max-w-lg select-none">{{ replyText() }}</span>
      </button>
      <button
        type="button"
        (click)="clearReply()"
        class="text-neutral-10 hover:text-neutral-12 p-1 rounded-full hover:bg-neutral-3 flex items-center justify-center cursor-pointer"
      >
        <mat-icon class="!w-4 !h-4 !text-[16px] flex items-center justify-center">close</mat-icon>
      </button>
    </div>
  }

  @if (hasExternalContact() && !hasConfirmedWarning()) {
    <aura-alert
      [alertInput]="{
        type: auraColorType.WARN,
        title: 'Partage de coordonnées interdit',
        message:
          'Conformément aux CGU, il est interdit de partager des informations de contact (téléphone, email, réseaux sociaux...).',
      }"
    >
      <div class="mt-1">
        <button
          type="button"
          (click)="confirmSendAnyway()"
          class="font-bold underline text-amber-12 hover:opacity-80 cursor-pointer text-xs"
        >
          Envoyer quand même
        </button>
      </div>
    </aura-alert>
  }

  <form [formGroup]="form" (ngSubmit)="send()" class="flex items-end gap-3 relative">
    <textarea
      #textareaEl
      rows="1"
      maxlength="4000"
      formControlName="message"
      (keydown.enter)="$event.preventDefault(); send()"
      placeholder="Écrire un message..."
      aria-label="Écrire un message"
      class="flex-1 rounded-2xl border border-neutral-3 bg-neutral-1 p-3 text-sm text-neutral-12 placeholder-neutral-10 focus:border-primary focus:outline-none transition-colors duration-300 resize-none overflow-y-auto"
      [class.transition-all]="isTransitioning()"
      [class.duration-300]="isTransitioning()"
    ></textarea>

    <!-- Buttons -->
    <div class="flex gap-2 items-center">
      <button
        type="submit"
        [disabled]="isSendDisabled()"
        class="size-10 rounded-full bg-primary text-primary-contrast disabled:bg-neutral-3 disabled:text-neutral-10 dark:disabled:bg-neutral-3/20 dark:disabled:text-neutral-10 flex items-center justify-center enabled:hover:scale-105 enabled:active:scale-95 transition-all enabled:cursor-pointer disabled:cursor-not-allowed"
      >
        <mat-icon class="size-5 text-lg flex items-center justify-center text-current">send</mat-icon>
      </button>
    </div>
  </form>

  @if (isNearLimit()) {
    <div
      class="text-[10px] self-end font-medium transition-all duration-200"
      [class.text-neutral-10]="charCount() < 4000"
      [class.text-error-11]="charCount() === 4000"
    >
      {{ charCount() }} / 4000
      @if (charCount() === 4000) {
        <span class="font-bold ml-1">(Limite atteinte)</span>
      }
    </div>
  }
</div>
